import type { XYChartLineSeriesProps } from '../types/xy-chart-props.js';

/**
 * Line series slot component.
 * @public
 */
export const LineSeries = (props: XYChartLineSeriesProps) => null;

LineSeries['displayName'] = 'XYChart.LineSeries';
